
<div class="container-fluid backup-page">

  <!-- Encabezado -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="backup-heading">
        <div class="backup-heading-icon">
          <i class="mdi mdi-database-lock"></i>
        </div>

        <div>
          <h4 class="mb-1">Centro de respaldos</h4>
          <p class="text-muted mb-0">
            Generación segura de respaldos del sistema
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center">

    <div class="col-12 col-xl-9">

      <!-- Tarjeta principal -->
      <div class="card backup-card">

        <div class="card-body p-4 p-lg-5">

          <!-- Estado de seguridad -->
          <div class="backup-security-banner">
            <div class="security-icon">
              <i class="mdi mdi-shield-lock-outline"></i>
            </div>

            <div>
              <h6 class="mb-1">Acceso restringido</h6>
              <p class="mb-0">
                Para generar un respaldo es necesario validar
                un token de autorización de superusuario.
              </p>
            </div>

            <div class="ms-auto">
              <span
                class="badge"
                [ngClass]="tokenValidated
                  ? 'bg-success-subtle text-success'
                  : 'bg-warning-subtle text-warning'">

                <i
                  class="mdi"
                  [ngClass]="tokenValidated
                    ? 'mdi-check-circle'
                    : 'mdi-shield-alert-outline'">
                </i>

                {{ tokenValidated ? 'Autorizado' : 'No autorizado' }}
              </span>
            </div>
          </div>

          <!-- Pasos del proceso -->
          <div class="backup-steps">

            <div
              class="backup-step"
              [class.active]="!tokenValidated"
              [class.completed]="tokenValidated">

              <div class="step-number">
                <i
                  *ngIf="tokenValidated"
                  class="mdi mdi-check">
                </i>

                <span *ngIf="!tokenValidated">1</span>
              </div>

              <div>
                <strong>Autorización</strong>
                <small>Validar token</small>
              </div>
            </div>

            <div class="step-connector"
              [class.completed]="tokenValidated">
            </div>

            <div
              class="backup-step"
              [class.active]="tokenValidated">

              <div class="step-number">
                <i class="mdi mdi-database-export-outline"
                  *ngIf="tokenValidated">
                </i>

                <span *ngIf="!tokenValidated">2</span>
              </div>

              <div>
                <strong>Respaldo</strong>
                <small>Generar archivo</small>
              </div>
            </div>

          </div>

          <!-- ========================= -->
          <!-- PASO 1: TOKEN -->
          <!-- ========================= -->

          <section
            class="backup-section"
            *ngIf="!tokenValidated">

            <div class="section-icon">
              <i class="mdi mdi-key-variant"></i>
            </div>

            <h5>Validación de superusuario</h5>

            <p class="text-muted">
              Ingresa el token de autorización para habilitar
              la generación del respaldo.
            </p>

            <form
              (ngSubmit)="validateSuperUserToken()"
              #tokenForm="ngForm">

              <div class="mb-3">

                <label
                  for="superUserToken"
                  class="form-label">
                  Token de superusuario
                </label>

                <input
                  id="superUserToken"
                  name="superUserToken"
                  type="password"
                  class="form-control backup-token-input"
                  [(ngModel)]="superUserToken"
                  placeholder="Ingresa tu token de autorización"
                  autocomplete="off"
                  autocapitalize="off"
                  spellcheck="false"
                  required
                  [disabled]="validatingToken"
                />

                <div class="form-text">
                  <i class="mdi mdi-information-outline me-1"></i>
                  El token se utilizará únicamente para validar
                  la autorización con el servidor.
                </div>

              </div>

              <!-- Error de validación -->
              <div
                *ngIf="tokenError"
                class="alert alert-danger d-flex align-items-start"
                role="alert">

                <i class="mdi mdi-alert-circle-outline me-2 fs-4"></i>

                <div>
                  <strong>Validación no completada</strong>
                  <p class="mb-0">{{ tokenError }}</p>
                </div>

              </div>

              <!-- Botón validar -->
              <div class="d-flex justify-content-end">

                <button
                  type="submit"
                  class="btn btn-primary backup-primary-button"
                  [disabled]="
                    !superUserToken?.trim() ||
                    validatingToken ||
                    !tokenForm.valid
                  ">

                  <span
                    *ngIf="validatingToken"
                    class="spinner-border spinner-border-sm me-2">
                  </span>

                  <i
                    *ngIf="!validatingToken"
                    class="mdi mdi-shield-check-outline me-2">
                  </i>

                  {{
                    validatingToken
                      ? 'Validando autorización...'
                      : 'Validar token'
                  }}

                </button>

              </div>

            </form>

          </section>

          <!-- ========================= -->
          <!-- PASO 2: GENERAR BACKUP -->
          <!-- ========================= -->

          <section
            class="backup-section"
            *ngIf="tokenValidated">

            <div class="backup-authorized">
              <div class="authorized-icon">
                <i class="mdi mdi-check-decagram"></i>
              </div>

              <div>
                <h5>Autorización confirmada</h5>
                <p class="text-muted mb-0">
                  Puedes continuar con la generación del respaldo.
                </p>
              </div>
            </div>

            <div class="backup-info-grid">

              <div class="backup-info-item">
                <i class="mdi mdi-database-outline"></i>

                <div>
                  <small>Operación</small>
                  <strong>Respaldo de base de datos</strong>
                </div>
              </div>

              <div class="backup-info-item">
                <i class="mdi mdi-shield-check-outline"></i>

                <div>
                  <small>Autorización</small>
                  <strong>Token validado</strong>
                </div>
              </div>

              <div class="backup-info-item">
                <i class="mdi mdi-file-document-outline"></i>

                <div>
                  <small>Resultado esperado</small>
                  <strong>Archivo de respaldo</strong>
                </div>
              </div>

            </div>

            <div class="alert alert-warning mt-4">
              <i class="mdi mdi-alert-outline me-2"></i>

              Verifica que la operación esté permitida y que exista
              espacio suficiente para almacenar el respaldo.
            </div>

            <!-- Error de generación -->
            <div
              *ngIf="backupError"
              class="alert alert-danger"
              role="alert">

              <i class="mdi mdi-alert-circle-outline me-2"></i>
              {{ backupError }}

            </div>

            <!-- Resultado de generación -->
            <div
              *ngIf="backupMessage"
              class="alert alert-success"
              role="status">

              <i class="mdi mdi-check-circle-outline me-2"></i>
              {{ backupMessage }}

            </div>

            <!-- Información del archivo -->
            <div
              *ngIf="backupFileName"
              class="backup-file-result">

              <i class="mdi mdi-file-check-outline"></i>

              <div>
                <small>Archivo generado</small>
                <strong>{{ backupFileName }}</strong>
              </div>

            </div>

            <!-- Acciones -->
            <div
              class="backup-actions d-flex flex-wrap justify-content-between gap-2 mt-4">

              <button
                type="button"
                class="btn btn-light"
                (click)="cancelBackup()"
                [disabled]="generatingBackup">

                <i class="mdi mdi-arrow-left me-2"></i>
                Cancelar

              </button>

              <button
                type="button"
                class="btn btn-primary backup-primary-button"
                (click)="generateBackup()"
                [disabled]="generatingBackup">

                <span
                  *ngIf="generatingBackup"
                  class="spinner-border spinner-border-sm me-2">
                </span>

                <i
                  *ngIf="!generatingBackup"
                  class="mdi mdi-database-export-outline me-2">
                </i>

                {{
                  generatingBackup
                    ? 'Generando respaldo...'
                    : 'Generar backup'
                }}

              </button>

            </div>

          </section>

        </div>
      </div>

      <!-- Aviso de seguridad -->
      <div class="backup-footer-note">
        <i class="mdi mdi-lock-check-outline"></i>

        <span>
          La autorización debe comprobarse en el servidor.
          La generación del respaldo requiere permisos suficientes
          y debe quedar registrada en una bitácora.
        </span>
      </div>

    </div>
  </div>
</div>
